import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import store from '@/store';
import { Options, Vue } from 'vue-class-component';
import { USER_CREATE_PASSWORD } from '@/store/actions/user';
import MessagesUtil from "@/utils/messagesUtil";
import { router } from "@/router";
import CenterTop from "@/components/layout/CenterTop.vue";
var CreatePasswordView = /*#__PURE__*/function (_Vue) {
  function CreatePasswordView() {
    var _this;
    _classCallCheck(this, CreatePasswordView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CreatePasswordView, [].concat(args));
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "passwordCreationForm", {
      password: '',
      repassword: ''
    });
    return _this;
  }
  _inherits(CreatePasswordView, _Vue);
  return _createClass(CreatePasswordView, [{
    key: "createPassword",
    value: function createPassword() {
      var _this2 = this;
      if (this.requiredFieldIsMissing()) {
        return;
      }
      this.errorMsg = '';
      this.loading = true;
      var user = store.getters.userConnected;
      store.dispatch(USER_CREATE_PASSWORD, {
        password: this.passwordCreationForm.password,
        repassword: this.passwordCreationForm.repassword,
        user: user
      }).then(function () {
        _this2.loading = false;
        _this2.errorMsg = '';
        _this2.success();
        router.push('/');
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "requiredFieldIsMissing",
    value: function requiredFieldIsMissing() {
      return !this.passwordCreationForm.password || !this.passwordCreationForm.repassword;
    }
  }, {
    key: "success",
    value: function success() {
      MessagesUtil.showSuccessMessage(this.$t('password_creation.password_created_toast.message').toString(), 5000);
    }
  }]);
}(Vue);
CreatePasswordView = __decorate([Options({
  components: {
    MainTitle: MainTitle,
    CenterTop: CenterTop
  }
})], CreatePasswordView);
export default CreatePasswordView;